<script lang="ts">
	import { toastMessages, type ToastMessageType } from '$lib/stores/toastMessageStore';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { flip } from 'svelte/animate';
	import { fly } from 'svelte/transition';

	export const themes = {
		danger: 'var(--dangerColor)',
		success: 'var(--successColor)',
		warning: 'var(--warningColor)',
		info: 'var(--dangerColor)',
		default: 'var(--successColor)',
	};

	const cssTheme = (toastMessage: ToastMessageType) =>
		themes[toastMessage.type as keyof typeof themes];
	const removeToast = (toastMessage: ToastMessageType) => toastMessages.remove(toastMessage.id);
</script>

<div class="toastQueue">
	{#each $toastMessages as toastMessage (toastMessage.id)}
		<div
			animate:flip
			class="toast"
			style="border-inline-start: {cssTheme(toastMessage)} 5px solid;"
			in:fly|global={{ y: 30 }}>
			<div class="content">
				<Icon icon="check" color={cssTheme(toastMessage)} size="26" />
				<p>{toastMessage.message}</p>
				<Icon
					icon="close"
					color={cssTheme(toastMessage)}
					size="26"
					onClick={() => void removeToast(toastMessage)} />
			</div>
		</div>
	{/each}
</div>

<style>
	.toastQueue {
		display: flex;
		position: fixed;
		z-index: var(--z-index-Toast-message);
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		margin-block: var(--gutterMedium) var(--gutterLargest);
		margin-inline: var(--gutterMedium) var(--gutterMedium);
		padding: 0;
		inset-block-end: 0;
		inset-inline-end: 0;
	}

	.toast {
		flex: 0 0 auto;
		min-inline-size: 300px;
		margin-block-end: var(--gutterSmall);
		border: none;
		border-radius: 2px;
		background: rgb(0 0 0 / 80%);
		color: white;
		border-inline-start: rgb(29 29 28 / 90%) 5px solid;
	}

	.content {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: var(--gutterMedium);
		font-size: var(--fontSizeSmall);
		font-weight: 500;
	}

	p {
		flex-grow: 1;
		max-inline-size: 300px;
		margin-block: 0;
		margin-inline: var(--gutterMedium);
		color: white;
	}

	@media screen and (max-width: 575px) {
		.toastQueue {
			inline-size: 100%;
			margin: var(--gutterSmallest);
		}
	}
</style>
